import styles from "../../../styles/Components/new-insight/chart-section/InsightsSignalCard.module.css";
import { Tooltip } from "antd";
import { MdAccessTime } from "react-icons/md";
import { useRelativeTime } from "../../../hooks/useRelativeTime";
import useServiceStatus from "../../../hooks/useServiceStatus";
import HiddenContent from "../../../ui/HiddenContent";

// signalType can be "1h" and "15m", 15m is for live signal
function InsightsSignalCard({ data = {}, title }) {
  const {
    other_info: { description = "", name = "" } = {},
    signal_description,
  } = data;
  const { signal_date: date = "", suggestion: signal = "" } = data;

  const { isActive: isInsightActive } = useServiceStatus("insight");

  const signalDate = useRelativeTime(date);

  if (!data?.other_info) return null;

  return (
    <div
      className={`${styles.container} ${isInsightActive ? styles?.[signal?.toLowerCase()] : ""}`}
    >
      <div className={styles.header}>
        <h4>{title}</h4>
        {/*<Tooltip*/}
        {/*  title={description}*/}
        {/*  color="geekblue"*/}
        {/*  className={styles.description}*/}
        {/*>*/}
        {/*  {description}*/}
        {/*</Tooltip>*/}
        <span className={styles.description}>{signal_description}</span>

        <span className={`${styles.signal} ${styles?.[signal?.toLowerCase()]}`}>
          {!isInsightActive ? <HiddenContent service="insai" /> : signal || "-"}
        </span>
      </div>

      <div className={styles.footer}>
        {/*<Tooltip*/}
        {/*  title={name}*/}
        {/*  color="geekblue"*/}
        {/*  className={`${styles.description} ${styles.signalSourceName}`}*/}
        {/*>*/}
        {/*  {name}*/}
        {/*</Tooltip>*/}
        <span className={`${styles.description} ${styles.signalSourceName}`}>
          {name}
        </span>

        <div className={styles.signalDate}>
          <MdAccessTime />
          {signalDate}
        </div>
      </div>
    </div>
  );
}

export default InsightsSignalCard;
